// extracted by mini-css-extract-plugin
module.exports = {"main":"ReviewCoursePage_main__11MtO"};